export default {
  name: 'レポダス',
  subTitle: 'ビデオを送るだけで瞬時にレポート作成 - 現場の報告業務を、もっとシンプルに',
  roles: {
    owner: 'オーナー',
    member: 'メンバー',
    reporter: 'レポーター',
  },
  teamContext: {
    switchConfirmTitle: 'チームを切り替えますか？',
    switchingTo: '切り替え先',
    yourRole: 'あなたの役割',
    cancel: 'キャンセル',
    switch: '切り替える',
    uploadConfirmTitle: 'レポートをアップロード',
    uploadTo: 'アップロード先チーム',
    changeTeam: 'チームを変更',
    upload: 'アップロード',
  },
  layout: {
    main: {
      profile: 'アカウント',
      greeting: '{name}さん',
      currentTeam: '現在のチーム',
      switchTeams: {
        title: 'チームを切り替える',
        joinNewTeam: '新しいチームに参加...',
      },
      joinNewTeam: {
        title: '新しいチームに参加',
        description: '招待コードがあれば、新しいチームに参加できます。',
        invitationCodePlaceholder: '招待コードを入力',
        btnJoin: '参加する',
        notifySuccess: '新しいチームに参加しました。',
        errors: {
          invalidCode: '無効な招待コードです。正しいコードを入力してください。',
          expiredCode: '招待コードの有効期限が切れています。',
          alreadyAccepted: 'この招待コードは既に使用されています。',
          wrongEmail: 'この招待コードはあなたのメールアドレス宛ではありません。',
          alreadyMember: 'あなたは既にこのチームのメンバーです。',
        },
      },
      menu: {
        videoList: 'レポート一覧',
        advancedSearch: '高度な検索',
        settings: 'ユーザー設定',
        profile: 'プロフィール',
        subscription: 'サブスクリプション',
        apiKey: 'APIキー',
        history: 'ご利用履歴',
        billing: 'お支払い',
      },
      footer: {
        privacyPolicy: 'プライバシーポリシー',
        termsOfUse: '利用規約',
        logout: 'ログアウト',
      },
    },
  },
  general: {
    copyToClipboard: 'クリップボードにコピー',
    copied: 'コピーしました！',
    quota: {
      minsUsed: '{used}/{total} 分使用済み',
      secsUsed: '{used}/{total} 秒使用済み',
      secPerMinsUsed: '{used} 秒 / {total} 分使用済み',
      minPerMinsUsed: '{used} 分 / {total} 分使用済み',
      uploadableLength: '投稿可能なビデオの長さ',
      title: 'ビデオレポート容量',
      loading: '容量を読み込み中...',
      used: '使用済み',
      remaining: '残り',
      total: '合計',
      warning: {
        approaching: '利用枠の上限に近づいています。プランのアップグレードをご検討ください。',
        critical: '利用枠がほぼ一杯です。もうすぐ動画をアップロードできなくなる可能性があります。',
        exceeded: '利用枠が上限に達しました。動画のアップロードを続けるには、プランをアップグレードしてください。',
      },
      freeTrialExpired: '無料トライアル期間終了',
      freeTrialExpiresOn: '無料トライアル終了日: {date}',
      freeTrialExpiresInDays: '無料トライアルはあと {days} 日で終了します',
      upgradeNow: '今すぐアップグレード',
    },
  },
  languages: {
    en: '英語',
    zh: '中国語',
    ja: '日本語',
    de: 'ドイツ語',
    fr: 'フランス語',
    es: 'スペイン語',
    ko: '韓国語',
    ar: 'アラビア語',
    ru: 'ロシア語',
    nl: 'オランダ語',
    it: 'イタリア語',
    pl: 'ポーランド語',
    pt: 'ポルトガル語',
    vi: 'ベトナム語',
    th: 'タイ語',
    id: 'インドネシア語',
    unknown: '不明',
  },
  modal: {
    error: 'エラー',
    close: '閉じる',
    cancel: 'キャンセル',
    confirm: '確認',
    submit: '送信',
    save: '保存',
    delete: '削除',
    ok: 'OK',
    back: '戻る',
  },
  login: {
    title: 'ログイン',
    subTitle: 'おかえりなさい！',
    email: 'メールアドレス',
    password: 'パスワード',
    forgotPasswordLink: 'パスワードをお忘れですか？',
    btnLogin: 'ログイン',
    doNotHaveAccount: 'アカウントをお持ちでないですか？',
    signUpWithEmail: 'アカウントを登録',
    or: 'または',
    signInWithGoogle: 'Googleでサインイン',
    termOfUse: '利用規約',
    privacyPolicy: 'プライバシーポリシー',
    errorLogin: {
      title: 'ログインに失敗しました',
      first: 'メールアドレスまたはパスワードが間違っています。もう一度入力してください。',
      second: '※Caps Lockがオフになっていることを確認し、正しく入力してください。',
    },
  },
  forgotPassword: {
    title: 'パスワードをお忘れの場合',
    description: {
      first: '登録されているメールアドレスにパスワード再設定用のURLを送信します。',
      second: 'メールアドレスを入力し、「送信」ボタンをクリックしてください。',
    },
    email: 'メールアドレス',
    login: 'ログイン画面へ戻る',
    btnSend: '送信',
    titleMessage: 'メールを確認してください',
    successForgotPassword:
      'このメールアドレスに関連付けられたアカウントがある場合、パスワードのリセット方法を記載したメールが送信されます。',
  },
  resetPassword: {
    title: 'パスワード再設定',
    password: 'パスワード',
    confirmationPassword: 'パスワード(確認)',
    login: 'ログイン画面へ戻る',
    btnSubmit: '送信',
    titleMessage: 'リセットリンクが無効です',
    successResetPassword: 'パスワードがリセットされました。再度ログインしてください。',
    error401ResetPassword:
      'このリンクは無効または期限切れです。ログイン画面の「パスワードをお忘れですか？」から再度リセットしてください',
  },
  signup: {
    signInWithGoogle: 'Googleで続行',
    and: 'と',
    or: 'または',
    title: 'アカウントを作成',
    btnSubmit: '続行',
    alreadyHaveAccount: 'すでにアカウントをお持ちですか？',
    login: 'ログイン',
    step1: {
      subTitle: 'アカウント作成のためのメールアドレスを入力してください',
      email: 'メールアドレス',
      descriptionAgreePolicyAndTerms: 'プライバシーポリシーおよび利用規約に同意してください。',
      checkboxAgreePolicyAndTerms: 'レポダスの',
      privacyPolicy: 'プライバシーポリシー',
      termsOfUse: '利用規約',
      agreementPostfix: 'に同意します。',
      invitationSection: {
        title: '招待コードをお持ちですか？',
        placeholder: '招待コードを入力（任意）',
        verify: '確認',
        verified: '招待コードが確認されました',
        teamName: 'チーム名',
        yourRole: 'あなたの役割',
      },
      errors: {
        emailIsExisting: 'このメールアドレスは既に登録されています。別のメールアドレスをご利用ください。',
        emailIsDeleted: 'このメールアドレスは使用できません。',
        invalidInvitationCode: '無効な招待コードです',
        expiredInvitationCode: '招待コードの有効期限が切れています',
        alreadyAccepted: 'この招待コードは既に使用されています',
        mustAgreeToTerms: 'プライバシーポリシーと利用規約に同意してください。',
      },
    },
    step2: {
      subTitle: 'レポダスで利用するパスワードを設定してください',
      password: 'パスワード',
    },
    step3: {
      title: '認証コード',
      subTitle: {
        first: '認証コードを以下のメールアドレスに送信しました：',
        second: 'メールをご確認のうえ、アカウントを認証して続行してください',
      },
      verificationCode: '認証コード：',
      didNotGetEmail: 'メールが届いていませんか？',
      resendCode: 'コードを再送する',
      orDoubleCheckYourEmailAddress: 'またはメールアドレスを再確認してください',
      successResendCode: {
        titleMessage: 'メールをご確認ください',
        bodyMessage: 'メールが届いていない場合は、メールアドレスを再確認の上、迷惑メールフォルダもご確認ください。',
      },
      errors: {
        tooManyRequest: '最近コードをリクエストしたばかりです。新しいコードのリクエストは5分後にお試しください。',
        wrongVerificationCode: '認証コードが間違っています。再度お試しください。',
        verificationCodeExpired: '認証コードの有効期限が切れています。新しいコードをリクエストしてください。',
      },
    },
  },
  userProfile: {
    title: 'ユーザー情報入力',
    subTitle: 'レポダス アカウント作成を完了するために、ユーザー情報を入力してください',
    name: '名前',
    companyOrganizationName: '会社 / 組織名',
    numberOfEmployees: {
      title: '従業員数',
      placeholder: '-- 選択してください --',
    },
    yourRole: {
      title: 'あなたの役職',
      placeholder: '-- 選択してください --',
      EXECUTIVE_CXO: '経営層',
      MANAGER_TEAM_LEAD: '管理職',
      STAFF_INDIVIDUAL_CONTRIBUTOR: '一般職・担当者',
      ENGINEER_DESIGNER_RESEARCHER: '専門職',
      STUDENT: '学生',
      OTHER: 'その他',
    },
    btnContinue: '送信',
  },
  userTeam: {
    title: 'チームに参加',
    subTitle: '招待コードをお持ちの場合は入力してください',
    continueWithoutTeam: 'チームに参加せずに続行',
    namesTeam: 'さんのチーム',
    joinTeam: '既存のチームに参加する',
    joinTeamDescription: '招待コードをお持ちの場合は、既存のチームに参加できます',
    joinTeamPlaceholder: '招待コード',
    btnContinue: '送信',
    joiningTeam: 'チームに参加中',
    creatingTeam: 'チームを作成中',
    pleaseWait: 'しばらくお待ちください...',
  },
  settingsProfile: {
    title: 'プロフィール',
    userInformation: {
      sidebar: 'ユーザー情報',
      title: 'ユーザー情報',
      name: 'ユーザー名',
      required: '※必須',
      companyName: '会社・組織名',
      numberOfEmployees: '従業員数',
      placeholder: '--- 選択してください ---',
      role: {
        title: '役職',
        EXECUTIVE_CXO: '経営層',
        MANAGER_TEAM_LEAD: '管理職',
        STAFF_INDIVIDUAL_CONTRIBUTOR: '一般職・担当者',
        ENGINEER_DESIGNER_RESEARCHER: '専門職',
        STUDENT: '学生',
        OTHER: 'その他',
      },
      btnCancel: 'キャンセル',
      btnSave: '保存',
      email: 'メールアドレス',
      manageByGoogle: 'このアカウントはGoogleで管理されています',
    },
    teamMembers: {
      sidebar: 'チーム・メンバー管理',
      title: 'チーム・メンバー管理',
      teamName: 'チーム名',
      teamNamePlaceholder: 'チーム名を入力',
      btnSave: '保存',
      yourRole: 'あなたの役割',
      members: 'メンバー',
      btnInviteNewMember: '新しいメンバーを招待',
      inviteNewMemberToYourTeam: 'チームに新しいメンバーを招待する',
      sendInvitation: '次の宛先に招待リンクを送信：',
      emailPlaceholder: 'メールアドレスを入力',
      selectRole: '役割を選択',
      roleDescription: {
        member: 'すべてのチームレポートを閲覧し、新しいレポートを作成できます',
        reporter: '自分のレポートのみを閲覧し、作成できます',
      },
      orShareThisCodeTitle: '招待コードが生成されました。',
      orShareThisCodeMessage: 'このコードは、上記Emailアドレスに限り有効です：',
      btnSend: '送信',
      btnSendAgain: 'もう一度送信',
      notify: {
        success: 'チーム名を正常に更新しました。',
        error: '招待コードの送信に失敗しました。もう一度お試しください。',
        inviteSuccess: '招待を正常に送信しました。',
      },
      popup: {
        title: 'このメンバーを完全に削除しますか？',
        btnCancel: 'キャンセル',
        btnDelete: '削除',
      },
      roles: {
        owner: 'オーナー',
        member: 'メンバー',
        reporter: 'レポーター',
      },
    },
    changeEmail: {
      sidebar: 'メールアドレスの変更',
      title: 'メールアドレスの変更',
      newEmail: '新しいメールアドレス',
      newEmailPlaceholder: '新しいメールアドレスを入力してください',
      newEmailConfirmPlaceholder: '新しいメールアドレス（確認）を入力してください',
      currentPassword: '現在のパスワード',
      currentPasswordPlaceholder: '現在のパスワードを入力してください',
      confirm: '確認',
      description: '新しいメールアドレスに確認コードを送信します。',
      btnSubmit: '送信',
      notify: {
        success: 'メールアドレスが正常に変更されました。',
        error: 'メールアドレスの変更に失敗しました。もう一度お試しください。',
      },
      popup: {
        title: '認証コード',
        subTitle: {
          first: '認証コードを以下のメールアドレスに送信しました：',
          second: 'メールをご確認のうえ、アカウントを認証して続行してください',
        },
        verificationCode: '認証コード：',
        didNotGetEmail: 'メールが届いていませんか？',
        orDoubleCheckYourEmailAddress:
          'しばらく時間をおいて再度お試しいただくか、入力したメールアドレスが正しいかご確認ください。',
        otp: 'OTPを入力',
        btnChangeEmailAddress: 'メールアドレスを変更',
        btnCancel: 'キャンセル',
        resendCodeSuccess: '認証コードが再送されました',
      },
    },
    changePassword: {
      sidebar: 'パスワードの変更',
      title: 'パスワードの変更',
      currentPassword: '現在のパスワード',
      currentPasswordPlaceholder: '現在のパスワードを入力してください',
      newPassword: '新しいパスワード',
      newPasswordPlaceholder: '新しいパスワードを入力してください',
      confirm: '確認',
      newPasswordConfirmPlaceholder: '新しいパスワード（確認）を入力してください',
      btnSave: '保存',
      notify: {
        success: 'パスワードが正常に変更されました。',
        error: 'パスワードの変更に失敗しました。もう一度お試しください。',
      },
    },
    deleteAccount: {
      sidebar: 'アカウントの削除',
      title: 'アカウント削除',
      dangerZone: '危険ゾーン',
      description:
        'この個人アカウントおよびすべてのコンテンツをプラットフォームから完全に削除します。この操作は取り消せないため、慎重に進めてください。',
      btnDelete: 'アカウントを削除',
      popup: {
        title: 'このアカウントを完全に削除しますか？',
        warningText: '続行するにはメールアドレスを入力してください',
        email: 'メールアドレスを入力してください',
        btnCancel: 'キャンセル',
        btnDelete: '削除する',
        error: 'アカウントを削除する前に、チームから他のメンバーをすべて削除してください。',
      },
    },
    logout: 'ログアウト',
  },
  subscription: {
    title: 'サブスクリプション',
    plan: {
      title: 'プランのアップグレード',
      selectPlan: 'プランを選択',
      loading: 'プラン情報を取得中...',
      customerSessionError: 'プラン情報を取得できませんでした。',
      invoiceTitle: '請求書払いでの購入',
      subscribeInvoice: '請求書払いでプランを購入',
      subscribe: 'プランを購入',
      interval: '支払い期間',
      invoiceSent: '請求書は登録されたメールアドレスに送信されます。',
      contactSalesTitle: 'エンタープライズ',
      contactSales: 'お問い合わせ',
      contactSalesDesc: 'クレジットカード・請求書払い',
      enterprisePlanUpgradeNote:
        '現在のプランの上限を超えるご利用については、お気軽に当社までご相談ください。\nお客様のニーズに応じた柔軟なご提案をさせていただきます。',
      month: '月',
      year: '年',
      businessPlan: 'ビジネスプラン',
      monthly: '月払い',
      yearly: '年払い',
      currentPlan: '現在のプラン',
      videoGenerationFree: '1ヶ月間無料でお試し（最大{min}分のビデオアップロード）',
      videoGeneration: '月に{min}分のビデオアップロード',
      enterprisePRapi: 'APIの利用',
      enterprisePRteam: '大規模なチームでの利用',
      enterprisePRdesc: 'ニーズに沿ったプランを用意していますので、お問い合わせください。',
      noActivePlan: 'アクティブなサブスクリプションプランがありません',
      nextRenewal: '次回更新日：',
      autoCheckoutTitle: 'サブスクリプションの購入',
      autoCheckoutMessage: 'パーソナルプランのお支払いページに移動します。続行しますか？',
      proceedToPayment: 'お支払いページへ',
    },
    haveCoupon: 'クーポンコードをお持ちですか？',
    hideCoupon: 'クーポンを非表示',
    couponPlaceholder: 'クーポンコードを入力',
  },
  contactSales: {
    title: 'お問い合わせフォーム',
    emailLabel: 'メールアドレス',
    emailPlaceholder: 'メールアドレスを入力してください',
    inquiryLabel: 'お問い合わせ内容',
    inquiryPlaceholder: 'お問い合わせ内容をご記入ください...',
    sendButton: '送信',
    backToSubscription: 'サブスクリプションに戻る',
    formValidationError: '必要な項目を正しく入力してください。',
    inquirySent: 'お問い合わせを送信いたしました。担当者より折り返しご連絡いたします。',
  },
  billing: {
    title: 'お支払い',
    manageButton: 'お支払い管理',
    error: '請求ポータルを開くことができませんでした。',
  },
  apiKey: {
    title: 'APIキー',
    subTitle: 'あなたのAPIキー',
    copySuccess: 'クリップボードにコピーしました',
    noKey: 'レポダス APIを利用するには、チームオーナーがAPIキーを生成する必要があります。',
    generateButton: 'APIキーを生成',
    generateSuccess: 'APIキー生成に成功しました',
    regenerateButton: '再生成',
    regeneratePopupTitle: 'APIキーの再生成',
    regenerateConfirm: 'APIキーを再生成しますか？既存のキーは無効になります。',
    regenerateSuccess: 'APIキーを再生成しました',
    generateError: 'APIキーの生成に失敗しました。後でもう一度お試しください。',
  },
  history: {
    title: 'ご利用履歴',
    range: '{start}～{end}件（全{total}件）',
    loading: 'ご利用履歴を取得中...',
    noHistory: 'ご利用履歴がありません。',
    error: 'ご利用履歴の取得に失敗しました。',
    pages: 'ページ',
    items: '件',
    tabs: {
      appHistory: 'アプリご利用履歴',
      apiHistory: 'APIご利用履歴',
    },
    table: {
      createdDatetime: 'ご利用日時',
      type: '種別',
      name: '名称',
      duration: '時間(分)',
      creator: '作成者',
    },
    startDate: '開始日',
    endDate: '終了日',
    periodLabel: '表示対象期間',
    separator: '〜',
    displayButton: '表示',
    dateError: '期間が正しくありません。開始日は終了日より前に設定してください。',
    noData: '指定された期間のご利用履歴はありません。',
    types: {
      report_generation: 'レポート生成',
    },
  },
  validation: {
    general: 'エラーが発生しました。後でもう一度お試しください。',
    invalid: '無効な値です。',
    email: '有効なメールアドレスを入力してください。',
    required: 'この項目は必須です。',
    min: '最低{length}文字を入力してください。',
    max: '最大{length}文字まで入力可能です。',
    alphaNumeric: '半角英数字のみ入力してください。',
    number: '数値を入力してください。',
    halfSizeLetter: '半角文字を入力してください。',
    greaterOrEqual: '値は{value}以上である必要があります。',
    confirmationPassword: 'パスワードが一致しません',
    confirmationEmail: 'メールアドレスが一致しません',
    match: '半角英数字で入力してください',
  },
  notification: {
    general: {
      unknownError: 'エラーが発生しました。後でもう一度お試しください。',
      fetchFailed: '{resource} の取得に失敗しました。後でもう一度お試しください。',
      createSuccess: '{resource}の作成に成功しました',
      createFailed: '{resource}の作成に失敗しました。後でもう一度お試しください。',
      createFailedWithZeroCapacity:
        'アクセスが集中しているため、{resource}の作成に失敗しました。後でもう一度お試しください。',
      updateSuccess: '{resource}の更新に成功しました',
      updateFailed: '{resource}の更新に失敗しました。後でもう一度お試しください。',
      deleteSuccess: '{resource}の削除に成功しました',
      deleteFailed: '{resource}の削除に失敗しました。後でもう一度お試しください。',
    },
    resource: {
      video: 'ビデオ',
      team: 'チーム',
      member: 'メンバー',
      user_information: 'ユーザー情報',
      quota: 'クォータ',
    },
  },
  errors: {
    errorGeneral: '現在リクエストの処理に問題が発生しています。しばらくしてから再試行してください。',
    quotaExceeded: '動画生成の上限に達しました。プランをアップグレードしてください。',
    freeTrialExpired: '無料トライアル期間が終了しました。引き続きご利用いただくにはプランをアップグレードしてください。',
  },
  // Video feature translations
  videos: {
    dateGroup: {
      today: '今日',
      yesterday: '昨日',
    },
    title: 'レポート一覧',
    searchByTags: 'タグで検索',
    searchPlaceholder: 'レポートを検索...',
    btnUpload: 'レポートを作成',
    btnRefresh: '更新',
    inprogress: '処理中',
    processing: '処理中...',
    processingFailed: '処理に失敗しました',
    noTitle: '無題のレポート',
    noDescription: '説明がありません',
    failed: '失敗',
    uploadedAt: 'アップロード日時',
    workDate: '作業日時',
    btnRetry: '再試行',
    btnDelete: '削除',
    messageConfirmDeletion: 'このレポートを完全に削除してもよろしいですか？',
    uploadedBy: 'レポーター：',
    create: {
      title: 'レポートを作成',
      optionCamera: 'カメラで撮影',
      optionCameraDesc: '今すぐ録画を開始',
      optionFile: 'ファイルから選択',
      optionFileDesc: '端末内の動画をアップロード',
    },
    camera: {
      permissionDenied: 'カメラへのアクセスが許可されていません',
      notSupported: 'お使いのブラウザはカメラ録画に対応していません',
      startRecording: '録画開始',
      stopRecording: '録画停止',
      cancel: 'キャンセル',
      retake: '撮り直す',
      useVideo: 'この動画を使用',
      recording: '録画中',
      maxDurationWarning: '録画時間が10分を超えました',
      preparing: 'カメラを準備中...',
      switchCamera: 'カメラ切替',
    },
    upload: {
      title: '動画をアップロード',
      textAboutVideo: '動画の説明:',
      placeholderAboutVideo: '動画の説明またはコンテキストを入力してください',
      textUploadImage: '動画内の人物の画像をアップロードしてください:',
      personName: '人物名',
      placeholderPersonName: '画像の人物の名前を入力してください',
      textUploadImageFile: 'アップロード',
      textDeleteImageFile: '削除',
      btnAddMore: 'さらに人物を追加',
      personError: 'このセクションには、名前と画像を入力してください',
      imageSizeError: 'ファイルサイズは10MB以下にしてください。',
      makeTrailer: 'トレイラーを生成',
      textMakeTrailer: 'トレイラー作成のためのコンテキスト:',
      placeholderMakeTrailer: 'トレイラーを作成するためのコンテキスト（文脈）を入力してください',
      btnGoToNextStep: '次へ',
      btnCancel: 'キャンセル',
      description: 'ドラッグ＆ドロップまたはクリックしてファイルを選択',
      maxSize: 'ファイル形式: MP4、MOV、M4V、WebM（最大2GB）',
      btnUpload: 'アップロードしてレポートを作成',
      bthGoToPreviousStep: '戻る',
      maxSizeVideo: 'ファイルサイズは100MB以下にしてください。',
      fileTooLarge: 'ファイルサイズが大きすぎます。2GB以下のファイルを選択してください。',
      largeFileWarning: '大容量ファイルはサーバーで最適化されます。',
      longDurationWarning: '10分を超える動画は処理に時間がかかる場合があります。',
      outputLanguage: '出力言語',
      invalidFormat: '無効なファイル形式です。MP4、MOV、M4V、WebMをアップロードしてください。',
    },
    btnViewMore: 'もっと見る',
    btnViewLess: '表示を減らす',
  },
  videoDetail: {
    btnViewFrameImages: 'もっと見る',
    btnSearch: '類似動画検索',
    btnSearchSimilarScenes: '類似シーン検索',
    btnMakeTrailer: 'トレイラーを生成',
    textMakeTrailer: 'トレイラー作成のためのコンテキスト:',
    placeholderMakeTrailer: 'トレイラーを作成するためのコンテキスト（文脈）を入力してください',
    btnMakeReport: 'レポートを生成',
    textMakeReport: 'レポート作成のためのコンテキスト:',
    placeholderMakeReport: 'レポートを作成するためのコンテキスト（文脈）を入力してください',
    btnCancel: 'キャンセル',
    filename: 'ファイル名:',
    workDate: '作業日時:',
    length: '動画時間:',
    watchFullVideo: '動画を視聴',
    description: '説明',
    tag: 'タグ',
    trailer: 'トレイラー',
    report: 'レポート',
    scenes: 'シーン',
    scene: 'シーン',
    sceneDescription: 'シーンの説明',
    frameImages: 'フレーム画像',
    processingTrailer: 'トレイラーを生成中...',
    processingReport: 'レポートを生成中...',
    created: '作成済',
    notCreated: '未作成',
    btnRegenerate: '再生成する',
    watchTrailerVideo: 'トレイラーを見る',
    openReport: 'レポートを見る',
    transcript: '文字起こし',
    original: '原文',
    translated: '翻訳',
    keyActions: '主要なアクション',
    detectedTexts: '検出されたテキスト (OCR)',
    at: '',
    spokenLanguage: '話されている言語',
  },
  advancedSearch: {
    title: '高度な検索',
    sceneMode: {
      descriptionFromText: 'シーンの説明',
      sceneText: 'シーン',
      fromText: '動画タイトル：',
      noteText: '注: このシーンは類似シーンの検索結果には表示されません。',
    },
    videoMode: {
      summaryFromText: '動画タイトル：',
      noteText: '注: この動画は類似動画の検索結果には表示されません。',
    },
    videos: '動画',
    scenes: 'シーン',
    inputSearchPlaceholder: '探したい物やストーリー、またはシーンを入力してください',
    descriptionError: '1024文字以下で入力してください。',
    additionalFilters: '絞り込みを追加する',
    resetFilters: '絞り込みをデフォルトにリセット',
    topKValue: '検索結果表示件数',
    searchMethod: {
      title: '検索方法',
      hybrid: 'ハイブリッド検索',
      semantic: 'セマンティック検索',
      keyword: 'キーワード検索',
    },
    searchScenesFrom: {
      title: 'シーンの検索元となる動画',
      all: 'すべての動画',
      current: 'この動画',
    },
    btnSearchSimilarVideo: '類似動画を検索',
    btnSearchSimilarScene: '類似シーンを検索',
    btnSearchRelevantVideo: '関連動画を検索',
    btnSearchRelevantScene: '関連シーンを検索',
  },
  similarVideo: {
    top10Picks: 'ランキングTOP{k}',
    filters: '検索条件: ',
    searchVideos: '動画検索',
    searchScenes: 'シーン検索',
    btnChange: '変更する',
    fromText: '動画タイトル：',
    btnViewMore: 'もっと見る',
    btnViewLess: '表示を減らす',
    similarityScore: '類似スコア:',
  },
  noSimilarVideo: {
    subTitleForVideo: '一致する動画が見つかりませんでした。',
    subTitleForScene: '一致するシーンが見つかりませんでした。',
    description: '検索条件や絞り込みを変更して再試行してください。',
  },
  noVideo: {
    subTitle: '現在、動画がありません。',
    description: 'この機能を使用するには、動画をアップロードしてください。',
    noSearchResult: '該当する動画はありません。',
  },
  popupMessage: {
    error: '問題が発生しました。もう一度お試しください。',
  },
};
